export default {"src":"/_next/static/media/apple-wallet.3bd157a4.svg","height":21,"width":27,"blurWidth":0,"blurHeight":0};